export default __webpack_public_path__ + "static/media/fureverhomes7.c93da074.png";